import VideoChatModal from './VideoChatModal';

export default VideoChatModal;
